import gql from 'graphql-tag';

export const suggestedDokkioLabelFragment = gql`
  fragment suggestedDokkioLabelFragment on SuggestedDokkioLabel {
    dokkioClass
    accountID
    id
    confidence
    name
  }
`;
export default suggestedDokkioLabelFragment;
